import DOMPurify from 'dompurify'

export interface ITocEntry {
  id: string
  text: string
  level: number
}

const slugify = (text: string) =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'section'

export const buildArticleContent = (html: string): { html: string; toc: ITocEntry[] } => {
  const clean = DOMPurify.sanitize(html || '')
  const container = document.createElement('div')
  container.innerHTML = clean

  const usedIds = new Map<string, number>()
  const headings = Array.from(container.querySelectorAll('h1, h2, h3'))
  const toc: ITocEntry[] = headings.map((heading) => {
    const text = heading.textContent || ''
    const base = slugify(text)
    const seen = usedIds.get(base) || 0
    usedIds.set(base, seen + 1)
    const id = seen === 0 ? base : `${base}-${seen + 1}`
    heading.setAttribute('id', id)
    return {
      id,
      text,
      level: Number(heading.tagName.substring(1)),
    }
  })

  return { html: container.innerHTML, toc }
}
